import { IoIosArrowDown } from 'react-icons/io'
import { Dropdown } from 'antd'
import { OptionRowPage } from '../../helper/dataCustomize'
import { useTranslation } from 'react-i18next'

export default function RowPerPageCustom({ currentSize, onChange }) {
  const { t } = useTranslation()
  return (
    <div
      className="fw-light mt-1 d-flex"
      style={{
        color: 'var(--color-on-base-content-low)',
        fontSize: '14px',
        fontWeight: 400
      }}
    >
      <span>{t('hrms_setting_location_row_page')} </span>
      <span>
        <Dropdown
          className="text-default"
          trigger={['click']}
          menu={{
            items: OptionRowPage.map((d) => ({
              key: d,
              label: d,
              onClick: () => onChange(d)
            }))
          }}
        >
          <span className="btn-filter pointer-event rounded-circle pt-1 pb-1 ps-2 pe-2">
            <span className="me-1">{currentSize}</span>
            <span className="my-auto">
              <IoIosArrowDown />
            </span>
          </span>
        </Dropdown>
      </span>
    </div>
  )
}
